import React from "react";
import { TripLocationNavigationDialogPresenter } from "./TripLocationNavigationDialogPresenter";

export interface LocationInfo {
  id: string;
  name: string;
  type: 'hangar' | 'ramp' | 'unassigned';
}

export interface TripInfo {
  tailNumber: string;
  startTime: Date;
  endTime: Date;
}

interface TripLocationNavigationDialogProps {
  open: boolean;
  onClose: () => void;
  currentLocation: LocationInfo;
  targetLocation: LocationInfo;
  tripInfo: TripInfo;
  onNavigateToLocation: (locationId: string, locationType: string, time: Date) => void;
  onStayCurrentLocation: (time: Date) => void;
}

export const TripLocationNavigationDialog: React.FC<TripLocationNavigationDialogProps> = ({
  open,
  onClose,
  currentLocation,
  targetLocation,
  tripInfo,
  onNavigateToLocation,
  onStayCurrentLocation,
}) => {
  // Handle navigation to target location
  const handleNavigateToTarget = () => {
    if (targetLocation.type !== 'unassigned') {
      onNavigateToLocation(
        targetLocation.id,
        targetLocation.type,
        tripInfo.startTime
      );
    }
    onClose();
  };

  // Handle staying in current location but jumping to time
  const handleStayInCurrent = () => {
    onStayCurrentLocation(tripInfo.startTime);
    onClose();
  };

  // Handle cancel
  const handleCancel = () => {
    onClose();
  };

  return (
    <TripLocationNavigationDialogPresenter
      open={open}
      onClose={onClose}
      currentLocation={currentLocation}
      targetLocation={targetLocation}
      tripInfo={tripInfo}
      onNavigateToTarget={handleNavigateToTarget}
      onStayInCurrent={handleStayInCurrent}
      onCancel={handleCancel}
    />
  );
};